import React, { useState } from 'react';
import styled from 'styled-components';

import Section from '../global/section';
import Top from '../top';

import htmlToReact from '../../util/htmlToReact';

const StyledVideo = styled.div`
	text-align: center;
	h2 {
		margin-bottom: 2rem;
	}
	.flex {
		display: flex;
		text-align: left;
		.left {
			padding-right: 2rem;
			width: 50%;
		}
		.right {
			width: 50%;
		}
		.question {
			cursor: pointer;
			position: relative;
			&:not(:first-child) {
				margin-top: 1rem;
				padding-top: 1rem;
				border-top: 1px solid ${(p) => p.theme.color.lightGrey};
			}

			img {
				content: ${(p) => p.icon};
				width: 15px;
				height: 15px;
				position: absolute;
				left: 0;
			}

			h4 {
				font-weight: 700;
				text-transform: uppercase;
				margin-left: 2rem;
				&:hover {
					color: ${(p) => p.theme.color.red};
				}
			}
			.answer {
				display: none;
				margin-left: 2rem;
				&.showAnswer {
					display: block;
				}

				ul {
					list-style-type: disc;
					padding-left: 1em;
					margin: 0.75em 0 1em;

					li {
						margin-bottom: 0.75em;
					}
				}
			}
		}
		@media all and (max-width: 868px) {
			flex-wrap: wrap;
			.left {
				padding-right: 0;
				width: 100%;
			}
			.right {
				width: 100%;
				.question:first-child {
					margin-top: 1rem;
					padding-top: 1rem;
					border-top: 1px solid ${(p) => p.theme.color.lightGrey};
				}
			}
		}
	}
`;

export default ({ data }) => {
	const { top, title, questionsLeft, questionsRight } = data;

	const [leftQuestions, setLeftQuestions] = useState(
		new Array(questionsLeft.length).fill(false)
	);
	const [rightQuestions, setRightQuestions] = useState(
		new Array(questionsRight.length).fill(false)
	);

	const toggleQuestions = (i, side) => {
		if (side === 'left') {
			let temp = [...leftQuestions];
			temp[i] = !temp[i];
			setLeftQuestions(temp);
		} else {
			let temp = [...rightQuestions];
			temp[i] = !temp[i];
			setRightQuestions(temp);
		}
	};

	return (
		<StyledVideo>
			<Section bg="light">
				<Top color="red">{top}</Top>
				<h2>{title}</h2>
				<div className="flex">
					<div className="left">
						{questionsLeft.map((x, i) => (
							<div
								className="question"
								onClick={() => toggleQuestions(i, 'left')}
								key={i}
							>
								<img
									src={leftQuestions[i] ? '/img/minus.svg' : '/img/plus.svg'}
									alt={leftQuestions[i] ? 'minus sign' : 'plus sign'}
								/>
								<h4>{x.question}</h4>
								<div
									className={`answer${leftQuestions[i] ? ' showAnswer' : ''}`}
								>
									{htmlToReact(x.answer)}
								</div>
							</div>
						))}
					</div>
					<div className="right">
						{questionsRight.map((x, i) => (
							<div
								className="question"
								onClick={() => toggleQuestions(i, 'right')}
								key={i}
							>
								<img
									src={rightQuestions[i] ? '/img/minus.svg' : '/img/plus.svg'}
									alt={rightQuestions[i] ? 'minus sign' : 'plus sign'}
								/>
								<h4>{x.question}</h4>
								<div
									className={`answer${rightQuestions[i] ? ' showAnswer' : ''}`}
								>
									{htmlToReact(x.answer)}
								</div>
							</div>
						))}
					</div>
				</div>
			</Section>
		</StyledVideo>
	);
};
